<template>
    <div>
        <div class="form-group">
            <input type="text" class="form-control" placeholder="Buscar..." v-model="search"/>
        </div>

        <div class="scroll-table-content">
            <table class="table table-hover">
                <thead class="lightgray-content">
                    <tr>
                        <th class="lightgray-content"></th>
                        <th class="lightgray-content">{{ $t('general.sector') }}</th>
                        <template v-if="zonas.length > 0 && zonas[0].precios">
                            <th v-if="!mostrar_precio_mas_alto_en_la_zona" class="lightgray-content">{{ $t('general.desde') }}</th>
                            <th v-else></th>
                        </template>
                        <th v-if="mostrarColumnaLibres" class="lightgray-content">{{ $t('general.libres') }}</th>
                    </tr>
                </thead>
                <tbody v-if="zonas">
                    <template v-for="(zona, index) in search_zonas">
                        <tr :key="index" @click="irAZona(zona)" v-if="zona.esta_disponible">
                            <td :style='"background-color: " + zona.color'></td>
                            <td>{{ zona.name }}</td>
                            <template v-if="zona.precios">
                                <td v-if="!mostrar_precio_mas_alto_en_la_zona">{{ zona.precios.length > 0 ?
                                    zona.precios[0].precio : 0 | formatear_precio }}</td>
                                <td v-else>{{ zona.precios.length > 0 ? zona.precios[zona.precios.length - 1].precio : 0
                                    | formatear_precio }}</td>
                            </template>
                            <td v-if="mostrarColumnaLibres">{{ zona.with_seats ? zona.libres : '' }}</td>
                        </tr>
                    </template>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td :colspan="mostrarColumnaLibres ? 4 : 3">
                            <LoaderComponent/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['zonas'],
        data() {
            return {
                search: null,
                mostrar_precio_mas_alto_en_la_zona: this.$store.getters.getTeatro.mostrar_precio_mas_alto_en_la_zona
            }
        },
        computed: {
            mostrarColumnaLibres: function() {
                return this.zonas.some(zona => zona.with_seats);
            },
            search_zonas: function() {
                if (this.search == null) {
                    return this.zonas;
                }

                var zonas = [];

                for (var i in this.zonas) {

                    if (this.zonas[i].name.toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
                        zonas.push(this.zonas[i]);
                    }
                }

                return zonas;
            },
        },
        methods: {
            irAZona(zona) {
                this.$emit('clickZona', zona);
            }
        },
    }
</script>

<style>
.tabla-sectores {
    overflow: scroll;
    height: 400px;
}
</style>
